import "./DepositWallet.scss"
import {PATHS} from "../../../routers/utils/Paths.links";
import {Link} from "react-router-dom";
import {IUser} from "../../../pages/ShopPage/components/Navbar/interface";

// Баланс у шапці: сума й кнопка «+», обидва ведуть на поповнення
const DepositWallet = ({ user }: { user: IUser }) => {
    return (
        <Link className="link-wallet" to={PATHS.DEPOSIT} title="Поповнити баланс">
            <span className="wallet-sum">{ Number(user.balance ?? 0).toFixed(2) } ₴</span>
            <span className="wallet-plus" aria-hidden="true">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                    <path d="M12 5v14M5 12h14" />
                </svg>
            </span>
        </Link>
    );
};

export default DepositWallet;
